// Generated by scripts/router/train.ts from router-data/corpus.jsonl. Do not edit by hand.
export const ROUTER_META = {
  "dim": 32768,
  "rows": 15000,
  "bytes": 220662,
  "intentTemperature": 0.9,
  "domainTemperature": 1,
  "params": {
    "intent": 0.7,
    "margin": 0,
    "domain": 0.55
  },
  "trust": 0.6,
  "topicTrust": 0.8,
  "veto": 0.12,
  "vetoBest": 0.45,
  "fueraTrust": 0.7
} as const;
